import React from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import DateBox from 'devextreme-react/date-box';
import { SelectBox } from 'devextreme-react/select-box';
import dayjs from 'dayjs';
import { TriStateCheckbox } from './TriStateCheckBox';
import { deleteStrangeCharacters } from '../../commonFunctions/commonFunctions';
import { Button, Checkbox } from '@material-ui/core';
import Form from '../panel/form/Form';
import { NumberBox, TextBox } from 'devextreme-react';
import { formatToCurrency } from '../../commonFunctions/FormatterFunctions';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox'

const useStyles = makeStyles((theme) => ({
  notchedOutline: {
    outline: 'none',
    border: 'none',
  },
  extraSmall: {
    paddingTop: 7,
    paddingLeft: 9,
    paddingBottom: 8,
  },
  root: {
    fontSize: '12px',
    '&Mui-disabled': { border: 'none' },
    border: '1px solid #ddd',
    outline: 'none',
    '&:focus-within': {
      borderColor: '#3B5158',
      padding: 0,
    },
  },
}));

function CustomInput(props) {
  const { label, type, value, id, error, error_text, onChange, readOnly, size, row, maxValue = 50 } = props;
  const classes = useStyles();
  let estilosDate = null;

  if (type === 'date') {
    estilosDate = props.estilos ? props.estilos : '';
  }

  let valueSelect = '';
  let options = props.options === undefined || Object.keys(props.options).length === 0 ? undefined : Array.from(props.options);
  if (type == 'select' && readOnly == true && options != undefined) {
    options.map((option, index) => {
      if (option.key == value || option.stateId == value) {
        valueSelect = option.value == undefined ? option.description : option.value;
      }
    });
  }
  return (
    <div className={row ? 'input-wrapper-row' : 'input-wrapper-col'}>
      {label ? <label htmlFor={id}>{label}</label> : null}
      {type === 'date' ? (
        readOnly ? (
          <div className="dateReadOnly">{value === '' || !value ? null : dayjs(value).format(props.datetype === 'datetime' ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY')}</div>
        ) : (
          <DateBox
            onValueChange={onChange}
            style={{ position: estilosDate.position, width: estilosDate.width, marginLeft: estilosDate.marginLeft, height: '30px' }}
            useMaskBehavior={true}
            showClearButton
            disabled={props.disabled}
            applyButtonText="Confirmar"
            cancelButtonText="Cancelar"
            value={value}
            onOpened={(event) => {
              const popUp = event.component._popup;
              popUp.option('closeOnTargetScroll', false);
              popUp.option('closeOnOutsideClick', false);
              const timebox = document.getElementsByClassName('dx-timeview-field')[0];

              //añade botón Limpiar al toolbar inferior:
              let toolBar = popUp.option('toolbarItems');

              const isAdded = toolBar.some((e) => e.id === 'clearDateButton');
              if (!isAdded && props.datetype === 'datetime') {
                toolBar.push({
                  location: 'center',
                  toolbar: 'bottom',
                  widget: 'dxButton',
                  id: 'clearDateButton',
                  options: {
                    text: 'Limpar',
                    onClick: () => {
                      props.clearField();
                      popUp.option('visible', false);
                    },
                  },
                });
              }
              popUp.option('toolbarItems', toolBar);
            }}
            type={props.datetype}
            displayFormat={props.datetype === 'datetime' ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy'}
          />
        )
      ) : type === 'select' ? (
        readOnly ? (
          <div style={{ marginLeft: '0px' }}>{valueSelect}</div>
        ) : (
          <SelectBox
            dataSource={props.options}
            value={value}
            searchEnabled
            showClearButton={!props.disableClear}
            noDataText={'Nenhuma opção disponível'}
            disabled={props.disabled}
            displayExpr={props.displayExpr}
            valueExpr={props.valueExpr}
            onValueChange={onChange}
            placeholder="Seleccionar"
            style={{ height: '30px' }}
          />
        )
      ) : type === 'checkbox' ? (

        <Checkbox
                disabled={readOnly}
                checked={value === '' || value === null ? false : value}
                color={"primary"}
                icon={<CheckBoxOutlineBlankIcon />}
                checkedIcon={<CheckBoxIcon color={readOnly ? 'disabled' : 'secondary'} />}
                indeterminateIcon={<IndeterminateCheckBoxIcon />}
                onChange={onChange}
                styles={{ marginLeft: props.marginLeft }}
              />

        // readOnly ? (
        //   // <div className="checkReadOnly">{value === '' || value === null ? '' : value ? 'Sim' : 'Não'}</div>
        //   // <TriStateCheckbox checked={value === '' || value === null ? false : value} disabled indeterminate={value === null || value === '' ? true : false} styles={{ marginLeft: props.marginLeft }} />
        //   <TriStateCheckbox checked={value === '' || value === null ? false : value} disabled onChange={onChange}  styles={{ marginLeft: props.marginLeft }} />
        // ) : (
        //   <div>
        //     {/* <TriStateCheckbox checked={value === '' || value === null ? false : value} onChange={onChange} styles={{ marginLeft: props.marginLeft }} /> */}
        //   </div>
        // )
      ) : type === 'number' ? (
        readOnly ? (
          <div style={{ marginLeft: '0px' }}>{value}</div>
        ) : (
          <NumberBox
            id={id}
            showSpinButtons={true}
            showClearButton={true}
            disabled={props.disabled}
            error={error}
            value={value}
            min={props.min || 0}
            InputProps={{
              classes: size === 'xxs' ? { root: classes.root, notchedOutline: classes.notchedOutline } : null,
            }}
            onValueChanged={onChange}
          />
        )
      ) : type === 'currency' ? (
        readOnly ? (
          <div style={{ marginLeft: '0px' }}>{formatToCurrency(value)}</div>
        ) : (
          <NumberBox
            id={id}
            format={{
              type: 'currency',
              precision: 2,
              currency: 'BRL',
            }}
            min={props.min || 0}
            showSpinButtons={true}
            showClearButton={true}
            disabled={props.disabled}
            value={value || 0}
            InputProps={{
              classes: size === 'xxs' ? { root: classes.root, notchedOutline: classes.notchedOutline } : null,
            }}
            onValueChanged={onChange}
          />
        )
      ) : readOnly ? (
        <div>{value === 0 ? null : value}</div>
      ) : (

        props.mask ? (
          <TextBox
            id={id}
            //name="CNPJ"
            disabled={props.disabled}
            mask={props.mask}
            placeholder={props.placeholder}
            showMaskMode={props.showMaskMode}
            maskRules={props.maskRules}
            value={value}
            onValueChanged={onChange}
            height={25}
          ></TextBox>
        ): (


        <TextField
          type={type || 'text'}
          id={id}
          variant={'outlined'}
          size={'small'}
          disabled={props.disabled}
          error={error}
          value={value}
          InputProps={{
            classes: size === 'xxs' ? { root: classes.root, notchedOutline: classes.notchedOutline } : null,
          }}
          onChange={(e) => e.target.value.length <= maxValue && onChange(deleteStrangeCharacters(e.target.value))}
          helperText={error_text}
        />
        )
      )}
    </div>
  );
}

export { CustomInput };
